import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NzModalService } from 'ng-zorro-antd/modal';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { AppsService } from 'src/app/shared/services/apps.service';

@Component({
  selector: 'app-vj-help-nav-bar',
  templateUrl: './vj-help-nav-bar.component.html',
  styleUrls: ['./vj-help-nav-bar.component.css']
})
export class VjHelpNavBarComponent {
  showSuccessMessage = false;
  isLoading: boolean = false;
  helpForm: FormGroup;
  categoryOption: string[] = ['Support-LegalJobs (PQI-JOBS)','Support-AuroraHub (PQI-HUB)','Support-Annual Business Review (PQI-ABR)',
'Support-Marketing (PUBLIC-WEB)','Support-Salesforce (SFDC-SYNC)','Login Support','Access Request','General Enquiry'];
  formEdited = false;
  constructor(private fb: FormBuilder, private appService: AppsService, private notification: NzNotificationService, private modalService: NzModalService,){
    
  }
  ngOnInit(): void {
    var userStorageData: any = {};
    userStorageData = JSON.parse(localStorage.getItem('user'));
   const userEmail = userStorageData['mail']
    this.helpForm = this.fb.group({
      yourEmail: [{ value: userEmail, disabled: true }, Validators.required],
      enquiryType: ['', Validators.required],
      description: ['', Validators.required]
    });
  }
  successSubmit() {
    this.isLoading = true;
    if (this.helpForm.valid) {
        const enquiryType = this.helpForm.get('enquiryType').value;
        const mailContent = this.helpForm.get('description').value;

        this.appService.sendEmailHelp(mailContent, enquiryType).subscribe(
            () => {
                this.showSuccessMessage = true; 
                this.isLoading= false;
                setTimeout(() => {
                    this.closeModal();
                }, 2000);
            },
            (error) => {
                this.notification.error('Error', 'An error occurred while sending the request.');
                this.isLoading = false;
                console.error(error);
            }
        );
    }
}

  closeModal(): void {
   
    this.modalService.closeAll(); 
  }
  
}

